
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts/AuthContext';
import { 
  Card, 
  CardContent, 
  CardHeader, 
  CardTitle,
  CardDescription
} from '@/components/ui/card';

// Import the new component files
import AccountForm from './account/AccountForm';
import UserStatus from './account/UserStatus';
import ActionButtons from './account/ActionButtons';

interface AccountSectionProps {
  user: any;
  resetQuiz: () => void;
  handleRestartQuiz: () => void;
}

const AccountSection: React.FC<AccountSectionProps> = ({ user, resetQuiz, handleRestartQuiz }) => {
  const [mode, setMode] = useState<'signup' | 'login'>('signup');
  
  const toggleMode = () => {
    setMode(mode === 'signup' ? 'login' : 'signup');
  };
  
  return (
    <Card className="max-w-3xl mx-auto mb-10">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl font-bold">Save Your Results</CardTitle>
        <CardDescription>
          {user 
            ? "Your results are saved to your account."
            : mode === 'signup' 
              ? "Create an account to save your results for future reference."
              : "Sign in to your account to save your results."
          }
        </CardDescription>
      </CardHeader>
      
      <CardContent>
        {!user ? (
          <AccountForm 
            mode={mode} 
            onToggleMode={toggleMode}
          />
        ) : (
          <UserStatus email={user.email} />
        )}
        
        <ActionButtons handleRestartQuiz={handleRestartQuiz} />
      </CardContent>
    </Card>
  );
};

export default AccountSection;
